<div class="card mb-2" *ngFor="let category of onboardingClient.onboardingCategoriesAndSteps">
  <div class="card-header line-item" (click)="onCategoryClick(category)">
    {{ category.description }}
    <ng-container *ngIf="category.isCompleted">
      <span class="icon-success far fa-circle-check"></span>
    </ng-container>
    <ng-container *ngIf="category.hasStarted && !category.isCompleted">
      <span class="icon-incomplete far fa-circle-question"></span>
    </ng-container>
  </div>

  <ng-container *ngIf="stepIsVisible(category)">
    <div class="card-body my-auto">
      <ul class="list-group list-group-light">
        <li
          class="list-group-item"
          *ngFor="let step of category.steps"
          [ngClass]="{
            'update-success': step.recentlyUpdated,
            'update-fail': step.error
          }"
        >
          <app-loading [busy]="step.isUpdating"></app-loading>
          <div class="d-sm-flex" style="justify-content: space-between">
            <ng-container *ngIf="!step.isUpdating">
              <ng-container *ngIf="step.emailTemplateId != null">
                <ng-container *ngIf="!step.isCompleted">
                  <div class="d-flex align-items-center">
                    <button
                      type="submit"
                      mdbBtn
                      color="trakly-action"
                      class="relative waves-light btn-sm btn"
                      (click)="toggleStepUpdate(step)"
                    >
                      Send
                    </button>
                    <div class="form-check line-item text-muted small ms-2" *ngIf="!step.isCompleted || !step.lastUpdatedDate">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="mark_as_sent_{{ step.id }}"
                        id="mark_as_sent_{{ step.id }}"
                        [checked]="step.isCompleted"
                        [disabled]="step.isUpdating || step.isCompleted"
                        (change)="markEmailStepAsSent(step)"
                      />
                      <label class="form-check-label" for="mark_as_sent_{{ step.id }}">Mark as Sent</label>
                    </div>
                  </div>
                  <div class="text-muted small">{{ step.description }}</div>
                </ng-container>
                <ng-container *ngIf="step.isCompleted">
                  <div class="d-flex align-items-center">
                    <button
                      type="submit"
                      mdbBtn
                      color="trakly-action"
                      class="relative waves-light btn-sm btn"
                      (click)="toggleStepUpdate(step)"
                    >
                      Re-send
                    </button>
                    <div class="form-check ms-2" *ngIf="!step.isCompleted || !step.lastUpdatedDate">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="mark_as_sent_{{ step.id }}"
                        id="mark_as_sent_{{ step.id }}"
                        [checked]="step.isCompleted"
                        [disabled]="step.isUpdating || step.isCompleted"
                        (change)="markEmailStepAsSent(step)"
                      />
                      <label class="form-check-label" for="mark_as_sent_{{ step.id }}">Mark as Sent</label>
                    </div>
                  </div>
                  <div class="text-muted small">
                    <div>{{ step.description }} <mdb-badge color="green">Sent</mdb-badge></div>
                    Last sent: {{ generateLastUpdatedDate(step) }}
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="step.emailTemplateId == null">
                <div class="form-check line-item text-muted small" *ngIf="!step.isUpdating">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="step_{{ step.id }}"
                    id="step_id_{{ step.id }}"
                    [(ngModel)]="step.isCompleted"
                    (change)="toggleStepUpdate(step)"
                  />
                  <label class="form-check-label" for="step_id_{{ step.id }}">{{ step.description }}</label>
                </div>
              </ng-container>
              <span *ngIf="step.error">
                <mdb-icon fas icon="circle-xmark" class="action-icon sortable" (click)="popupError(step.error)"></mdb-icon>
              </span>
            </ng-container>
            <mdb-badge class="badge-wealth-primary my-auto" *ngIf="isWealth">ID: {{ step.id }}</mdb-badge>
          </div>
        </li>
      </ul>
    </div>
  </ng-container>
</div>
<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
